import { BasicPage } from '@/components/layout/BasicPage'
import { Button } from '@/components/action/Button'
import { Icon } from '@/components/graphics/Icon'
import { toastError, toastSuccess } from '@/components/action/Toaster'
import { useApi } from '@/hooks/useApi'
import { routes } from '@/utilities/routes'
import { iconsAvailable, type IconName } from '@/components/graphics/iconsAvailable'
import './Icons.css'

export function Icons() {

  const api = useApi({
    requireLogin: true,
    adminOnly: true,
  })

  const names = Object.keys(iconsAvailable) as IconName[]

  async function copyName(name: string) {
    try {
      await navigator.clipboard.writeText(name)
      toastSuccess('Copied to clipboard')
    } catch {
      toastError('Failed to copy to clipboard')
    }
  }

  return (
    <BasicPage
      title='Icons'
      className='Icons'
    >

      <ul className='List'>
        {names.map(name => (
          <li
            key={name}
            className='Item'
            role='button'
            tabIndex={0}
            title='Click to copy icon name'
            onClick={() => copyName(name)}
            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); copyName(name) } }}
          >
            <span className='Icon'>
              <Icon icon={name} />
            </span>
            <code className='Name'>{name}</code>
          </li>
        ))}
      </ul>
    </BasicPage>
  )
}
